define(['jquery', 'forms', 'jqueryuicustom'], function ($, Forms) {

	var FileUploadHelper = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.forms = new Forms();

		self.fileAlreadyUploaded = function (fileName, $uploadedFilesList) {
			return $uploadedFilesList.find('li a[data-originalfilename="' + fileName + '"]').length;
		};

		self.setupUploadedFilesSectionHeader = function ($uploadedFilesList) {
			var $heading = $uploadedFilesList.parent().find('.heading'),
				$headingParentField = $heading.parents('.field.no-space-right');

			if ($uploadedFilesList.find('.delete-file').length) {
				$heading.removeClass('hide');

				if ($headingParentField.length && $heading.parents('.multi-file').length === 0) {
					$headingParentField.removeClass('hide');
				}
			} else {
				$heading.addClass('hide');
			}
		}

		self.setupCheckedFile = function (validFile, $uploadContainer, data) {
			var $currentUploaded = $uploadContainer.find('[data-view="uploaded"]').first(),
				$currentNotUploaded = $uploadContainer.find('[data-view="notuploaded"]').first(),
				$fileUploadNameInput = self.$ervBody.find('#UploadedFileName');

			if (validFile) {
				$currentUploaded.removeClass('hide');
				$currentUploaded.find('.heading').removeClass('hide');
				$currentNotUploaded.addClass('hide');

				if (typeof (data) !== 'undefined') {
					$fileUploadNameInput.val(data.result.FileName);
					$fileUploadNameInput.removeClass('input-validation-error');
				}
			} else {
				$currentUploaded.addClass('hide');
				$currentNotUploaded.removeClass('hide');
				$fileUploadNameInput.val('');
			}
		}

		self.statusFromData = function (data, $validation) {
			var $genericError = $validation.find('[data-js="generic"]');
			$genericError.removeClass('hide');

			if (data && typeof (data.result) !== 'undefined') {
				if (typeof (data.result.Message) !== 'undefined') {
					$genericError.html(data.result.Message);
				} else if (typeof (data.result) == 'string') {
					$genericError.html(data.result);
				}
			}
		}

		self.hideErrors = function ($validation) {
			$validation.find('span').addClass('hide');
			$validation.parent().find('.field-validation-error').remove();
		};

		self.deleteUploadedFile = function ($file, $uploadContainer) {
			var $selectFile = $uploadContainer.find('[data-js="select-file"]'),
				$validation = $uploadContainer.find('[data-js="file-validation"]'),
				$uploadedFilesList = $selectFile.find('.uploaded-files ul'),
				removeFileUrl = $selectFile.data('remove-url');

			self.hideErrors($validation);
			self.forms.activateLoading($uploadContainer, false);

			$.ajax({
				url: removeFileUrl,
				data: { guid: $file.data('guid'), name: $file.data('originalfilename') }
			}).success(function () {
				$file.closest('li').remove();
				self.setupSingleFile($uploadedFilesList);
				self.setupUploadedFilesSectionHeader($uploadedFilesList);
			}).error(function () {
				$validation.find('.remove-file').removeClass('hide');
			}).always(function () {
				self.forms.deactivateLoading($uploadContainer);
			});
		};

		self.deleteCheckedFile = function ($link, $uploadContainer) {
			var $validation = $uploadContainer.find('[data-js="file-validation"]'),
				$uploadedFilesList = $uploadContainer.find('.uploaded-files ul');

			$link.remove();
			self.setupUploadedFilesSectionHeader($uploadedFilesList);
			self.setupCheckedFile(false, $uploadContainer);
			self.hideErrors($validation);

			$('body').trigger({
				type: 'ervPersonFileCheckedRemoved'
			});
		};

		self.setupSingleFile = function ($uploadedFilesList) {
			var $parentContainer = $uploadedFilesList.parents('.file-upload');

			var $parentField = $uploadedFilesList.parents('.field'),
				$button = $parentContainer.find('.btn');


			if ($parentContainer.hasClass('multi-file') || $parentContainer.hasClass('single-file')) {
				if ($uploadedFilesList.find('li').length) {
					$parentField.removeClass('hide');
				} else {
					$parentField.addClass('hide');
				}
			}

			if ($parentContainer.hasClass('single-file')) {
				$parentField.removeClass('width-50');

				if ($uploadedFilesList.find('li').length) {
					$button.parent().addClass('hide');
				} else {
					$button.parent().removeClass('hide');
				}

				var $disableUpload = $uploadedFilesList.parents('.upload-document').find('[data-js="disable-upload"]');

				if ($disableUpload) {
					var $disableUploadContainer = $disableUpload.parents('.missing-file');

					if ($parentContainer.find('.uploaded-files ul li').length > 0) {
						$disableUploadContainer.addClass('hide');
						$disableUploadContainer.removeClass('checked');
						self.forms.disableFormElementsInContainer($disableUploadContainer, true, true);
					} else {
						$disableUploadContainer.removeClass('hide');
						$disableUploadContainer.addClass('checked');
						self.forms.disableFormElementsInContainer($disableUploadContainer, false, true);
					}

					$disableUpload.on('click', function () {
						var $currentCheckbox = $(this),
							$currentDocumentElement = $currentCheckbox.parents('.document-element'),
							$currentButtonContainer = $currentDocumentElement.find('.single-file'),
							$currentButton = $currentButtonContainer.find('.btn'),
							$currentReasonContainer = $currentDocumentElement.find('.missing-file-reason'),
							$currentReasonInput = $currentReasonContainer.find('[data-js="reason"]');

						$currentCheckbox.val($currentCheckbox.prop('checked'));

						if ($currentCheckbox.prop('checked')) {
							self.forms.disableFormElementsInContainer($currentReasonInput, false, true);
							$currentButton.addClass('hide');
							$currentReasonContainer.removeClass('hide');
							$disableUploadContainer.addClass('checked');
						} else {
							self.forms.disableFormElementsInContainer($currentReasonInput, true, true);
							$currentButton.removeClass('hide');
							$currentReasonContainer.addClass('hide');
							$currentButtonContainer.removeClass('hide');
							$disableUploadContainer.removeClass('checked');
						}
					});
				}
			}
		}

		self.updateUploadedFiles = function (data, $uploadedFilesList) {
			if (data != null) {
				var $template = self.$ervBody.find('[data-js="file-template"]'),
					dataGuid = '',
					fileName = '',
					fileOriginalName = '',
					$validation = $uploadedFilesList.parents('.file-upload').find('[data-js="file-validation"]');

				if (typeof (data) == 'string') {
					data = $.parseJSON(data); data.Files = data.Files || [];
					dataGuid = data.Files[0].Guid;
					fileName = data.result.Files[0].FileName;
					fileOriginalName = data.Files[0].OriginalFileName;
				} else {
					dataGuid = data.result.Files[0].Guid;
					fileName = data.result.Files[0].FileName;
					fileOriginalName = data.result.Files[0].OriginalFileName;
				}

				if (self.fileAlreadyUploaded(fileOriginalName, $uploadedFilesList)) {
					$validation.find('[data-js="fileexists"]').removeClass('hide');
				} else {
					self.hideErrors($validation);
					self.elementFileToList($template, fileName, fileOriginalName, dataGuid, $uploadedFilesList);
				}

				self.setupUploadedFilesSectionHeader($uploadedFilesList);
			} else {
				$uploadedFilesList.parent().find('.heading').addClass('hide');
			}

			self.setupSingleFile($uploadedFilesList);
		}

		self.updateCheckedFile = function (data, $uploadedFilesList) {
			if (data != null) {
				var $template = self.$ervBody.find('[data-js="file-template"]');
				$uploadedFilesList.empty();

				self.elementFileToList($template, data.result.FileName, data.result.FileName, data.result.Guid, $uploadedFilesList);

				$('body').trigger({
					type: 'ervPersonFileCheckedAndApproved',
					persons: data.result.Persons,
					currentCategoryForm: $uploadedFilesList.parents('.insurance-fields')
				});
			}
		}

		self.elementFileToList = function ($template, fileName, originalFileName, guid, $uploadedFilesList) {
			var $html = $template.html()
				.replace(/{{filename}}/g, fileName)
				.replace(/{{originalfilename}}/g, originalFileName)
				.replace(/{{guid}}/g, guid);

			$uploadedFilesList.append($html);
		};

		self.isAllowedFile = function (extension, $selectFile) {
			var ext = extension.match(/\.([^.]+)$/)[1],
				allowedTypes = $selectFile.data('file-types').toLowerCase();

			return allowedTypes.indexOf(ext.toLowerCase()) > 0;
		};

		self.triggerUploadHandler = function ($uploadContainer) {
			var $selectFile = $uploadContainer.find('[data-js="select-file"]');

			if (!$selectFile) {
				return;
			}

			var $validation = $uploadContainer.find('[data-js="file-validation"]');

			$uploadContainer.find('[data-js="trigger-select-file"]').on('click', function (e) {
				e.preventDefault();
				$selectFile.find('[data-js="filesource"]').click();
				self.hideErrors($validation);
			});
		};

		self.uploadFilesHandler = function ($uploadContainer) {
			var $selectFile = $uploadContainer.find('[data-js="select-file"]');

			if (!$selectFile) {
				return;
			}

            var addFileParams = {
                guid: $uploadContainer.parent().data('guid'),
                documentType: $uploadContainer.parent().data('type')
            };

            var $validation = $uploadContainer.find('[data-js="file-validation"]'),
				$uploadedFilesList = $uploadContainer.find('.uploaded-files ul'),
				addFileUrl = $selectFile.data('add-url')+ "?" + $.param(addFileParams);

			self.setupSingleFile($uploadedFilesList);

			if (self.$ervBody.find('.file-upload').length) {
				require(['iframetransport', 'fileupload'], function () {
					$uploadContainer.find('[data-js="filesource"]').fileupload({
						url: addFileUrl,
						dataType: 'json',
						add: function (e, data) {
							data.submit();
						},
						change: function (e, data) {
							self.forms.activateLoading($uploadContainer, false);
							self.hideErrors($validation);

							if (!self.isAllowedFile(data.files[0].name, $selectFile)) {
								$validation.find('[data-js="filetype"]').removeClass('hide');
								self.forms.deactivateLoading($uploadContainer);
								return false;
							} else if (self.fileAlreadyUploaded(data.files[0].name, $uploadedFilesList)) {
								$validation.find('[data-js="fileexists"]').removeClass('hide');
								self.forms.deactivateLoading($uploadContainer);
								return false;
							}
						},
						fail: function (e, data) {
							self.statusFromData(data, $validation);
						},
						done: function (e, data) {
							if (data.result.Status === 'success') {
								self.updateUploadedFiles(data, $uploadedFilesList);
							} else {
								self.statusFromData(data, $validation);
							}
						},
						always: function (e) {
							self.forms.deactivateLoading($uploadContainer);
						}
					});
				});
			}
		};

		self.checkFileHandler = function ($uploadContainer) {
			var $selectFile = $uploadContainer.find('[data-js="select-file"]'),
				$validation = $uploadContainer.find('[data-js="file-validation"]'),
				$uploadedFilesList = $uploadContainer.find('.uploaded-files ul'),
				$uploadContainerParent = $uploadContainer.parent(),
				checkFileUrl = $uploadContainer.data('check-url');

			if (self.$ervBody.find('.file-upload').length) {
				require(['iframetransport', 'fileupload'], function () {
					$uploadContainer.find('[data-js="filesource"]').fileupload({
						url: checkFileUrl,
						dataType: 'json',
						add: function (e, data) {
							self.forms.activateLoading($uploadContainerParent, false);

							self.hideErrors($validation);

							if (self.isAllowedFile(data.files[0].name, $selectFile)) {

								if (self.fileAlreadyUploaded(data.files[0].OriginalFileName, $uploadedFilesList)) {
									$validation.find('[data-js="fileexists"]').removeClass('hide');
									self.forms.deactivateLoading($uploadContainerParent);
								} else {
									data.submit();
								}

							} else {
								$validation.find('[data-js="filetype"]').removeClass('hide');
								self.forms.deactivateLoading($uploadContainerParent);
							}
						},
						fail: function (e, data) {
							self.statusFromData(data, $validation);
							self.setupCheckedFile(false, $uploadContainer);
						},
						done: function (e, data) {
							if (data.result.Status === 'success') {
								self.setupCheckedFile(true, $uploadContainer, data);
								self.updateCheckedFile(data, $uploadedFilesList);
							} else {
								self.statusFromData(data, $validation);
								self.setupCheckedFile(false, $uploadContainer);
							}
						},
						always: function (e) {
							self.forms.deactivateLoading($uploadContainerParent);
						}
					});
				});
			}
		};
	};

	//used in claimsstepthree
	FileUploadHelper.prototype.initUploadFiles = function ($uploadContainers) {
		var self = this;

		$uploadContainers.each(function () {
			var $uploadContainer = $(this);

			self.triggerUploadHandler($uploadContainer);
			self.uploadFilesHandler($uploadContainer);

			$uploadContainer.on('click', 'li .delete-file', function (e) {
				e.preventDefault();
				self.deleteUploadedFile($(this), $uploadContainer);
			});
		});
	};

	//used in bookingwidget
	FileUploadHelper.prototype.initCheckFile = function ($uploadContainers) {
		var self = this;
		$uploadContainers.each(function () {
			var $uploadContainer = $(this);

			self.triggerUploadHandler($uploadContainer);
			self.checkFileHandler($uploadContainer);

			$uploadContainer.on('click', 'li .delete-file', function (e) {
				e.preventDefault();
				self.deleteCheckedFile($(this), $uploadContainer);
			});
		});
	};

	return FileUploadHelper;
});